var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BDC3C7;}\r\n\t.st1{fill:#ECF0F1;}\r\n\t.st2{fill:#E74C3C;}\r\n\t.st3{fill:#C0392B;}\r\n\t.st4{fill:#95A5A6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M85.1,73.3c-26.8,0-48.8,22.1-48.8,48.8v341.1c0,26.8,22.1,48.8,48.8,48.8h146.5h48.8h146.5 c26.8,0,48.8-22.1,48.8-48.8V122.1c0-26.8-22.1-48.8-48.8-48.8H280.4h-48.8H85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M85.1,48.8c-26.8,0-48.8,22.1-48.8,48.8v341.1c0,26.8,22.1,48.8,48.8,48.8h146.5h48.8h146.5 c26.8,0,48.8-22.1,48.8-48.8V97.7c0-26.8-22.1-48.8-48.8-48.8H280.4h-48.8H85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st2",
    d: "M85.1,48.8c-26.8,0-48.8,22.1-48.8,48.8v73.3v24.4H475v-24.4V97.7c0-26.8-22.1-48.8-48.8-48.8 H280.4h-48.8H85.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st3",
    cx: 109.5,
    cy: 109.5,
    r: 36.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7_",
    className: "st3",
    cx: 402.5,
    cy: 109.5,
    r: 36.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M85.1,244.2V293h48.8v-48.8H85.1z M158.3,244.2V293h48.8v-48.8H158.3z M231.6,244.2V293h48.8 v-48.8H231.6z M304.8,244.2V293h48.8v-48.8H304.8z M378.1,244.2V293h48.8v-48.8H378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st0",
    d: "M85.1,316.7v48.8h48.8v-48.8H85.1z M158.3,316.7v48.8h48.8v-48.8H158.3z M231.6,316.7v48.8 h48.8v-48.8H231.6z M304.8,316.7v48.8h48.8v-48.8H304.8z M378.1,316.7v48.8h48.8v-48.8H378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M85.1,389.9v48.8h48.8v-48.8H85.1z M158.3,389.9v48.8h48.8v-48.8H158.3z M231.6,389.9v48.8 h48.8v-48.8H231.6z M304.8,389.9v48.8h48.8v-48.8H304.8z M378.1,389.9v48.8h48.8v-48.8H378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st4",
    d: "M109.5,0C96.1,0,85.1,11,85.1,24.4v73.3c0,13.4,11,24.4,24.4,24.4s24.4-11,24.4-24.4V24.4 C133.9,11,122.9,0,109.5,0z M402.5,0c-13.4,0-24.4,11-24.4,24.4v73.3c0,13.4,11,24.4,24.4,24.4c13.4,0,24.4-11,24.4-24.4V24.4 C426.9,11,415.9,0,402.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st0",
    d: "M109.5,0C96.1,0,85.1,9.5,85.1,24.4v48.8h48.8V24.4C133.9,9.5,122.9,0,109.5,0z M402.5,0 c-13.4,0-24.4,9.5-24.4,24.4v48.8h48.8V24.4C426.9,9.5,415.9,0,402.5,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d94621f18ae69849871a3e092e5f13d2.svg";
export { ForwardRef as ReactComponent };